import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
    selector: 'option:not([value])[lunaValue]',
    standalone: false
})
export class SelectOptionDirective {
    @Input()
    lunaValue: any;

    constructor(
        public elementRef: ElementRef
    ) {
    } 

    ngOnInit() {
        (this.elementRef.nativeElement as any).objectValue = this.lunaValue;
    }
}
